import type { Client } from '@/core/domain';
import type { ClientRepository } from '../repositories/client-repository';

export class GetAllClientsByUserIdUseCase {
  constructor(private readonly repository: ClientRepository) {}

  async execute(userId: string): Promise<Client[]> {
    return this.repository.getAllByUserId(userId);
  }
}
